import React, { useState } from "react";
import styles from "../../../CSS/sections/HomeAccordion.module.css";

const HomeAccordion = ({ content }) => {
  const { leftCard, items } = content;
  const { title, description } = leftCard;
  const [activeId, setActiveId] = useState(null);

  const onEnter = (e, id) => {
    if (e?.pointerType === "mouse") setActiveId(id);
  };
  const onLeave = (e) => {
    if (e?.pointerType === "mouse") setActiveId(null);
  };

  return (
    <>
      <section className={`${styles.accordionSection} padding-y`}>
        <div className="container">
          <div className={styles.accordionLayout}>
            <div className={styles.leftCol}>
              <div className={styles.accordionLeftCard}>
                <h2
                  className={`${styles.accordionLeftCardTitle} heading2 text-light`}
                >
                  {title}
                </h2>
                <p className={`p16 font-medium text-light`}>{description}</p>
              </div>
            </div>
            <div className={styles.rightCol}>
              <div className={`accordion ${styles.accordion}`}>
                {items.map((item) => {
                  const isOpen = activeId === item.id;
                  return (
                    <div
                      key={item.id}
                      className={`accordion-item ${styles.accordionItem}`}
                      onPointerEnter={(e) => onEnter(e, item.id)}
                      onPointerLeave={onLeave}
                    >
                      <h4 className="accordion-header">
                        <button
                          type="button"
                          className={`accordion-button ${styles.accordionButton
                            } ${isOpen ? "" : "collapsed"}`}
                          aria-expanded={isOpen}
                          onClick={() =>
                            setActiveId((prev) =>
                              prev === item.id ? null : item.id
                            )
                          }
                        >
                          <span className={styles.iconWrap}>
                            {item.icon ? (
                              <img
                                src={item.icon}
                                alt=""
                                aria-hidden="true"
                                className={styles.icon}
                              />
                            ) : null}
                          </span>
                          <span className={styles.headerText}>
                            <h4 className="heading4 mb-2 font-semibold">
                              {item.header.title}
                            </h4>
                            <p className="p16 mb-2 font-semibold">
                              {item.header.subtitle}
                            </p>
                            <div
                              className={`accordion-collapse collapse ${isOpen ? "show" : ""
                                }`}
                            >
                              <div
                                className={`accordion-body ${styles.accordionBody}`}
                              >
                                <p className="p14 mb-0 font-medium">
                                  {item.body}
                                </p>
                              </div>
                            </div>
                          </span>
                        </button>
                      </h4>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeAccordion;
